(function () {
  function initReadMore(scope) {
    const wrappers = (scope || document).querySelectorAll(".rm");

    wrappers.forEach((wrap) => {
      const content = wrap.querySelector(".rm__content");
      const toggle = wrap.querySelector(".rm__toggle button, .rm__toggle a");

      if (!content || !toggle) return;

      // If content doesn't overflow, hide the toggle
      // (measure using a temporary unclamp)
      const wasExpanded = wrap.classList.contains("is-expanded");
      wrap.classList.add("is-expanded");
      const fullHeight = content.scrollHeight;
      wrap.classList.remove("is-expanded");
      const clampedHeight = content.getBoundingClientRect().height;

      if (fullHeight <= clampedHeight + 2) {
        wrap.classList.add("rm--no-toggle");
        toggle.style.display = "none";
        return;
      }

      // restore state if it was expanded
      if (wasExpanded) wrap.classList.add("is-expanded");

      toggle.addEventListener("click", (e) => {
        e.preventDefault();

        const expanded = wrap.classList.toggle("is-expanded");
        toggle.setAttribute("aria-expanded", expanded ? "true" : "false");

        const more = toggle.getAttribute("data-more") || "Read more";
        const less = toggle.getAttribute("data-less") || "Read less";
        toggle.textContent = expanded ? less : more;
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => initReadMore(document));

  // Shopify Theme Editor (dynamic reloads)
  document.addEventListener("shopify:section:load", (event) => {
    initReadMore(event.target);
  });
})();